/* istanbul ignore file */
import {
    InfoBox,
    Map,
    Marker,
    Polygon,
    Polyline,
    withMap,
    withScript as withScriptjs,
} from '@elparking/map'
import { getConstant } from 'commons/js/constants'

const googleMapProps = {
    language: getConstant('LANGUAGE'),
    apiKey: getConstant('GOOGLEMAPS_API_KEY'),
    region: getConstant('COUNTRY_ISO2'),
    libraries: ['places', 'geometry', 'marker'],
}

export {
    Map,
    withMap,
    InfoBox,
    Marker,
    Polyline,
    Polygon,
    withScriptjs,
    googleMapProps,
}
